import { useAPIQuery } from "@dev2_techwalnut/tw-api-query-hook";
import { Table } from "@dev2_techwalnut/tw-react-crud-dashlite";
import React, { Fragment } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { trimDecimals } from "../../utils/trim-decimal";

const BatchInsightsDetails = () => {
    const location = useLocation();
    const navigate = useNavigate();

    const data = location.state?.data;

    const { useFetch } = useAPIQuery({
        key: `/api/batch-insights/${data?.id}/`,
        endpoint: `/api/batch-insights/${data?.id}/`,
    });

    const { data: batchData, isFetching } = useFetch({
        abortOnNewRequest: true,
        refetchOnWindowFocus: true,
        staleTime: 300000,
        retry: 3,
        keepPlaceholder: true,
        refetchOnReconnect: true,
    });

    const updatedData = batchData?.[0];

    console.log(updatedData);

    const salesOrdersColumns = [
        {
            accessor: "sales_order_code",
            header: "Sales Order Code",
        },
        {
            accessor: "product",
            header: "Item Name",
        },
        {
            accessor: "allotted_quantity",
            header: "Allotted Quantity",
            cell: (row) => (
                <span>{trimDecimals(row?.allotted_quantity, 5)}</span>
            ),
        },
    ];

    const workOrdersColumns = [
        {
            accessor: "work_order_code",
            header: "Work Order Code",
        },
        {
            accessor: "product",
            header: "Item Name",
        },
        {
            accessor: "allotted_quantity",
            header: "Allotted Quantity",
            cell: (row) => (
                <span>{trimDecimals(row?.allotted_quantity, 5)}</span>
            ),
        },
    ];

    const dailyPlanColumns = [
        {
            accessor: "daily_plan_code",
            header: "Daily Plan Code",
        },
        {
            accessor: "item",
            header: "Item Name",
        },
        {
            accessor: "allotted_quantity",
            header: "Allotted Quantity",
            cell: (row) => (
                <span>{trimDecimals(row?.allotted_quantity, 5)}</span>
            ),
        },
    ];

    const purchaseOrderColumns = [
        {
            accessor: "po_number",
            header: "PO Number",
        },
        {
            accessor: "allotted_quantity",
            header: "Allotted Quantity",
            cell: (row) => (
                <span>{trimDecimals(row?.allotted_quantity, 5)}</span>
            ),
        },
    ];

    const requisitionsColumns = [
        {
            accessor: "requisition_code",
            header: "Requisition Code",
        },
        {
            accessor: "item_name",
            header: "Item Name",
        },
        {
            accessor: "requested_quantity",
            header: "Requested Quantity",
            cell: (row) => (
                <span>{trimDecimals(row?.requested_quantity, 5)}</span>
            ),
        },
        {
            accessor: "allotted_quantity",
            header: "Allotted Quantity",
            cell: (row) => {
                const allotted = Number(row?.allotted_quantity || 0);
                const requested = Number(row?.requested_quantity || 0);
                const over = allotted > requested + 0.0001;
                return (
                    <span
                        className={over ? "text-danger" : undefined}
                        title={
                            over
                                ? "Allotted exceeds requested quantity"
                                : undefined
                        }
                    >
                        {trimDecimals(row?.allotted_quantity, 5)}
                        {over ? " (over requested)" : ""}
                    </span>
                );
            },
        },
    ];
    return (
        <Fragment>
            <div className="nk-block-head nk-block-head-sm">
                <div className="nk-block-between">
                    <div className="nk-block-head-content">
                        <h4 className="nk-block-title">
                            {`Batch insights (${updatedData?.batch_number})`}
                        </h4>
                    </div>
                    <button
                        className="btn btn-sm btn-secondary"
                        onClick={() => navigate(-1)}
                    >
                        Back
                    </button>
                </div>
            </div>
            <div className="card">
                <div className="card-inner">
                    <div className="nk-block">
                        <div className="profile-ud-list">
                            <div className="profile-ud-item">
                                <div className="profile-ud wider">
                                    <span className="profile-ud-label">
                                        Item Name
                                    </span>
                                    <span className="profile-ud-value">
                                        {updatedData?.item}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="card">
                <div className="card-header">Sales Orders</div>
                <div className="card-body">
                    <Table
                        data={updatedData?.allotments?.sales_orders || []}
                        columns={salesOrdersColumns}
                        isLoading={isFetching}
                        globalSearch={false}
                        pagination={false}
                        manualFilter={false}
                        manualSorting={false}
                        editRows={false}
                        deleteRows={false}
                        filterModal={false}
                        selectRows={false}
                        maxHeight={500}
                    />
                </div>
            </div>
            <div className="card">
                <div className="card-header">Work Orders</div>
                <div className="card-body">
                    <Table
                        data={updatedData?.allotments?.work_orders || []}
                        columns={workOrdersColumns}
                        isLoading={isFetching}
                        globalSearch={false}
                        pagination={false}
                        manualFilter={false}
                        manualSorting={false}
                        editRows={false}
                        deleteRows={false}
                        filterModal={false}
                        selectRows={false}
                        maxHeight={500}
                    />
                </div>
            </div>
            <div className="card">
                <div className="card-header">Daily Plans</div>
                <div className="card-body">
                    <Table
                        data={updatedData?.allotments?.daily_plans || []}
                        columns={dailyPlanColumns}
                        isLoading={isFetching}
                        globalSearch={false}
                        pagination={false}
                        manualFilter={false}
                        manualSorting={false}
                        editRows={false}
                        deleteRows={false}
                        filterModal={false}
                        selectRows={false}
                        maxHeight={500}
                    />
                </div>
            </div>
            <div className="card">
                <div className="card-header">Purchase Orders</div>
                <div className="card-body">
                    <Table
                        data={updatedData?.allotments?.purchase_orders || []}
                        columns={purchaseOrderColumns}
                        isLoading={isFetching}
                        globalSearch={false}
                        pagination={false}
                        manualFilter={false}
                        manualSorting={false}
                        editRows={false}
                        deleteRows={false}
                        filterModal={false}
                        selectRows={false}
                        maxHeight={500}
                    />
                </div>
            </div>
            <div className="card">
                <div className="card-header">Requisitions</div>
                <div className="card-body">
                    <Table
                        data={updatedData?.allotments?.requisitions || []}
                        columns={requisitionsColumns}
                        isLoading={isFetching}
                        globalSearch={false}
                        pagination={false}
                        manualFilter={false}
                        manualSorting={false}
                        editRows={false}
                        deleteRows={false}
                        filterModal={false}
                        selectRows={false}
                        maxHeight={500}
                    />
                </div>
            </div>
        </Fragment>
    );
};

export default BatchInsightsDetails;
